import { cn } from 'lib/helpers/utility';
import { DEVICE_SIZES, useWindowSize } from 'lib/hooks/useWindowSize';

import StepSidebar from '../Sidebar/Sidebar';
import LoginSlot from '../LoginSlot/LoginSlot';
import AssistanceCard from '../SmartSuggestions/AssistanceCard';
import SmartSuggestions from '../SmartSuggestions/SmartSuggestions';

const StepperSidebar = ({
  stepsState,
  phases,
  sidebarType,
  hiddenSubstepCodes,
  restrictedStepsCodes,
  isNarrowScreen,
  sidebarOpen,
  closeSidebar,
  isEnteringFromIntro,
  smartSuggestions,
  isAdmin,
  practiceId,
  SmartSuggestionsComponent = SmartSuggestions,
  AssistanceCardComponent = AssistanceCard, // No intercom for self-scheduling and other flows in stepper
  BottomSlot = null,
  LoginComponent = LoginSlot,
  onExpandStep,
  onCollapseStep,
  onActivateStep,
  onNavigateSubstep
}) => {
  const { device } = useWindowSize();
  const sidebarContent = (isNarrow) => (
    <>
      <div
        className={cn(
          'stepper-sidebar flex min-h-0 flex-col sm:flex-1',
          isEnteringFromIntro && 'entering'
        )}>
        <StepSidebar
          stepsState={stepsState}
          phases={phases}
          sidebarType={sidebarType}
          hiddenSubstepCodes={hiddenSubstepCodes}
          restrictedStepsCodes={restrictedStepsCodes}
          onExpandStep={onExpandStep}
          onCollapseStep={isNarrow ? undefined : onCollapseStep}
          onActivateStep={(code) => {
            onActivateStep(code);
            if (isNarrow) {
              closeSidebar();
            }
          }}
          onNavigateSubstep={(code) => {
            onNavigateSubstep(code);
            if (isNarrow) {
              closeSidebar();
            }
          }}
        />
      </div>
      <div
        className={cn(
          'flex flex-col gap-4',
          device === DEVICE_SIZES.MOBILE && 'absolute bottom-0 z-50 w-full gap-0'
        )}>
        {SmartSuggestionsComponent && (
          <div
            className={cn(
              'stepper-smart-suggestions flex-shrink-0',
              isEnteringFromIntro && 'entering'
            )}>
            <SmartSuggestionsComponent smartSuggestions={smartSuggestions} />
          </div>
        )}
        {AssistanceCardComponent && (
          <div
            className={cn(
              'stepper-assistance-card flex-shrink-0',
              isEnteringFromIntro && 'entering'
            )}>
            <AssistanceCardComponent
              isAdmin={isAdmin}
              practiceId={practiceId}
              isNarrowScreen={isNarrowScreen}
              closeSidebar={closeSidebar}
            />
          </div>
        )}
        {BottomSlot && (
          <div
            className={cn('stepper-bottom-slot flex-shrink-0', isEnteringFromIntro && 'entering')}>
            <BottomSlot />
          </div>
        )}
        {LoginComponent && (
          <div
            className={cn(
              'stepper-login-component flex-shrink-0',
              isEnteringFromIntro && 'entering'
            )}>
            <LoginComponent />
          </div>
        )}
      </div>
    </>
  );

  return (
    <>
      {!isNarrowScreen && (
        <aside className="flex h-full w-80 flex-none flex-col gap-4 backdrop-blur-sm">
          {sidebarContent(false)}
        </aside>
      )}

      {isNarrowScreen && sidebarOpen && (
        <div
          onClick={closeSidebar}
          className="fixed inset-0 z-[100] bg-black/30 backdrop-blur-[2px] transition-opacity duration-300"
        />
      )}

      {isNarrowScreen && (
        <aside
          className={cn(
            'fixed left-0 top-0 z-[110] flex h-full w-80 flex-col gap-4 bg-transparent p-4 transition-transform duration-300 ease-in-out',
            sidebarOpen ? 'translate-x-0' : '-translate-x-full',
            device === DEVICE_SIZES.MOBILE && 'p-0'
          )}>
          {sidebarContent(true)}
        </aside>
      )}
    </>
  );
};

export default StepperSidebar;
